export default "__VITE_ASSET__D3oJ_o3p__"